import { isPlatform } from '@ionic/react';
import { ExecutionLoads } from '../models/ExecutionLoads.model';
import { Favorite } from '../models/home/favorite.model';
import { Recent } from '../models/home/recent.model';
import { IONICWrapper, isEntitled } from './common';
import { Roles } from './constants';
import { getUserRole } from './UserDetails.util';

/**
 * mock offline JSON
 * to be removed once the API is availabe
*/
const fullDate = 'Mon, 01 Jan 2001 00:00:00 GMT';
const offlineJSON: any = {
  configVer: '1.0',
  contentParams: {
    termsAndConditions: '0.0',
    eula: '0.0',
    privacy: '0.0',
    contactOptions: '0.0',
    videoWalkthroughs: '0.0',
    aboutSchneider: '0.0',
    becomingCarrier: '0.0',
    faq: '0.0',
    schneiderOfferings: '0.0'
  },
  UserId: {
    searchParams: {
      RecommendedLoads: fullDate,
      RecommendedLoadsInterval: '5',
      WatchedLoads: fullDate,
      WatchedLoadsInterval: '10',
      RecentSearch: fullDate,
      RecentSearchInterval: '10',
      FavouriteSearch: fullDate,
      FavouriteSearchInterval: '10'
    },
    shipmentParams: {
      shipment: fullDate,
      shipmentInterval: '10'
    }
  }
};

// DONT REMOVE BELOW COMMENTED CODE....
// const checkUserIdInOfflineData = (): boolean => {
//   let check = false;
//   const keys = Object.keys(props.getOfflineData);
//   keys.forEach((key: any) => {
//     if (key === IONICWrapper.details.auth.user.upn) {
//       check = true;
//     }
//   })
//   return check;
// }

/**
 * get the offline related API details based on the USER.
*/
export const offlineDataPerUserStart = (props: any) => {

  if ((isPlatform('desktop') || isPlatform('mobileweb'))) {
    return;
  }

  if (props.getOfflineData[
    IONICWrapper.details.auth.user.upn
  ]) {
    const { searchParams, shipmentParams } = props.getOfflineData[
      IONICWrapper.details.auth.user.upn
    ];
    props.findSearchData(props.userDetails && props.userDetails.memberDetailsResponse &&
      props.userDetails.memberDetailsResponse.member &&  props.userDetails.memberDetailsResponse.member.carrierId, searchParams);
    props.findShipmentInfo(IONICWrapper.details.auth.user.upn, shipmentParams);
  }
};

/**
 * get the offline related details based on the USER.
*/
export const getOfflineDetails = (props: any) => {

  if (props.isNetworkAvailable && !(isPlatform("desktop") || isPlatform("mobileweb"))) {
    props.storeAccessToken(IONICWrapper.details.auth.tokens);
    if (props.getOfflineData === null) {
      const keys = Object.keys(offlineJSON);
      keys.forEach((key: any) => {
        let newKey;
        if (key === 'UserId') {
          newKey = IONICWrapper.details.auth.user.upn;
        } else {
          return;
        }
        offlineJSON[newKey] = offlineJSON[key];
        delete offlineJSON[key];
      });
      props.createOfflineJSON(offlineJSON);
    }
    if (props.getOfflineData && props.getOfflineData.configVer) {
      props.initializeModule(props.getOfflineData.configVer);
    }
  }
  props.myLoadData();
}

/**
 * get recent search details.
*/
export const getRecentSearchData = (props: any) => {
  if ((isPlatform('desktop') || isPlatform('mobileweb'))) return;
  const role = getUserRole(props);
  if (
    props.getSearchParams &&
    props.getSearchParams.RecentSearch === true &&
    (role === Roles.carrierDispatcher || role === Roles.carrierGuest)
  ) {
    const modelRecent: Recent = new Recent();
    modelRecent.userID =
      (props.userDetails && props.userDetails.memberDetailsResponse &&
        props.userDetails.memberDetailsResponse.member &&  props.userDetails.memberDetailsResponse.member.upn) || '';
    modelRecent.carrierId =
      (props.userDetails && props.userDetails.memberDetailsResponse &&
        props.userDetails.memberDetailsResponse.member &&  props.userDetails.memberDetailsResponse.member.carrierId) || '';
    modelRecent.page = 0;
    modelRecent.size = 10;
    props.recentLoads(modelRecent.getRequestPayload(), false);
  }
}

/**
 * get favorite search details.
*/
export const getFavoriteSearchData = (props: any) => {
  if ((isPlatform('desktop') || isPlatform('mobileweb'))) return;
  const role = getUserRole(props);
  if (
    props.getSearchParams &&
    props.getSearchParams.FavouriteSearch === true &&
    (role === Roles.carrierDispatcher || role === Roles.carrierGuest)
  ) {
    const modelFavorite: Favorite = new Favorite();
    modelFavorite.userID =
      (props.userDetails && props.userDetails.memberDetailsResponse &&
        props.userDetails.memberDetailsResponse.member &&  props.userDetails.memberDetailsResponse.member.upn) || '';
    modelFavorite.carrierId =
      (props.userDetails && props.userDetails.memberDetailsResponse &&
        props.userDetails.memberDetailsResponse.member &&  props.userDetails.memberDetailsResponse.member.carrierId) || '';
    modelFavorite.page = 0;
    modelFavorite.size = 10;
    props.favoriteLoads(modelFavorite.getFavoritePayload(), false);
  }
}

/**
 * get shipment data.
*/
export const getShipmentData = (props: any) => {
  if ((isPlatform('desktop') || isPlatform('mobileweb'))) return;
  const role = getUserRole(props);
  if (
    props.getShipmentParams &&
    props.getShipmentParams.shipment === true &&
    (role === Roles.carrierDriver || role === Roles.carrierDispatcher)
  ) {
    const isDriver = !isEntitled('myLoad', 'carrierAssigned');
    const _model: ExecutionLoads = new ExecutionLoads();
    if (isDriver) {
      _model.driverId = props.userDetails && props.userDetails.memberDetailsResponse &&
      props.userDetails.memberDetailsResponse.member &&  props.userDetails.memberDetailsResponse.member.upn;
    }
    _model.filter = {
      carrierAssigned: isEntitled('myLoad', 'carrierAssigned'),
      driverAssigned: true,
      inTransit: true,
      carrierTendered:true,
      deliveredNeedsPaperWork: true,
      deliveredWithPaperWork: true
    };
    props.fetchShipments(_model.getRequestPayload());
  }
}
